import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../utils/redux';

/* This is just copy of get-user request because we need to update logged user info on page reload
 * and not to store it as a target user in context. Our target user saga is watching on success request for
 * user profiles, so it's a separated request only for fetching user on page reload.
 * */

export const consts = createReqConsts('profile', 'getLoggedUser');
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'profiles',
  type: 'get',
  slug: [
    {
      type: 'payload',
      selector: ['id'],
    },
  ],
});
export default createReqReducer(consts);



// WEBPACK FOOTER //
// ./src/redux/profiles/get-logged-user.js